import request from '@/util/request'

// 赛事注册表单配置详情
export const getCompetitionFormConfigInfo = (competitionId) => {
  return request({
    url: `/api/business/competition/form/config/info/${competitionId}`,
    method: 'GET',
  })
}
